module.exports = __webpack_public_path__ + "img/story1.2a2d4f12.png";